import styled from 'styled-components';

export const MainContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Main = styled.main<{ isTransportCloud?: boolean }>`
  flex: 1;
  ${({ isTransportCloud }) =>
    isTransportCloud &&
    `
    overflow: hidden;
  `}
`;

export const PageLayout = styled.div<{ isTransportCloud?: boolean }>`
  padding: ${({ isTransportCloud }) =>
    isTransportCloud ? '0px 24px 24px' : '0px 24px 48px'};
  ${({ isTransportCloud }) =>
    isTransportCloud &&
    `
    max-height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  `}
`;

export const PageWrap = styled.div<{
  isHidden?: boolean;
  disableOverflow?: boolean;
}>`
  height: ${({ isHidden }) => (isHidden ? '0px' : '100%')};
  width: ${({ isHidden }) => (isHidden ? '0px' : '100%')};
  ${({ disableOverflow }) => (disableOverflow ? '' : 'overflow-y: hidden')};
`;
